import { Form } from "react-bootstrap";
import BodyInputFormat from "./BodyInputFormat";
import { IFormInputDefault } from "./interfaces";
import { addData, getData } from "./utils";

interface IFormInputProps extends IFormInputDefault{
}

export default function FormImput({
  title,
  name,
  state,
  onChange,
  ...props
}:IFormInputProps){

  let {cleanable, onClear, ...props_aux} = props;
  if(state && name){
    props_aux["name"] = name;
    props_aux["defaultValue"] = state.model?getData(state.model,name):"";
  }

  return (
    <BodyInputFormat props={{...props,title}}>
      <Form.Control size="sm"
        onChange={(event:any)=>{
          if(state && name){
            let value = event.target.value;

            state.setModel((old:any)=>{
              return addData(old,name,value);
            });
          }if(onChange)onChange(event)
        }} 
        {...props_aux}
      />
    </BodyInputFormat>
  );
}